import { Box, ButtonBase, useTheme } from "@mui/material";
import { tokens } from "../../../../theme";


import { useTranslation } from "react-i18next";
import PopoverModal from "../../../theme/Modal/PopoverModal";
import NotificationsContent from "../../Notifications/Notifications";
import TopbarNews from "../views/TopbarNews";
import { ReactComponent as TableEmpty } from '../../../../styles/svg/tableempty.svg'
import Heading from "../../../theme/text/Heading";
import Text from "../../../theme/text/Text";
import Subheading from "../../../theme/text/Subheading";
import TabView3 from "../../../theme/TabView3/TabView3";
import { notificationsConfig } from "./NotificationsConfig";
import { useEffect, useState } from "react";
import DoneAllOutlinedIcon from '@mui/icons-material/DoneAllOutlined';
import { useNavigate } from "react-router-dom";
import { useMarkAllNotificationsAsReadMutation } from "../../../../newapi/pwa/pwaSlice";
import { showToastMessage } from "../../../../utils/toasts";
import { useSelector } from "react-redux";
import { ENV_TYPES } from "../../Sidebar";

const MPONotifications = (props) => {
    const theme = useTheme();
    const {t,i18n} = useTranslation();
    const colors = tokens(theme.palette.mode);
    const navigate = useNavigate();
    
    let isStandAlone = false;
    if (window.matchMedia('(display-mode: standalone)').matches) {
        isStandAlone = true;
    }

    const selectedEnvironmentType = useSelector((state) => state.settings.environment.selectedEnvironmentType);
    const isRelation = selectedEnvironmentType === ENV_TYPES[200];

    const [config, setConfig] = useState(notificationsConfig(theme,colors,t,navigate,props.onClose,isRelation));

    useEffect(() => {
        setConfig(notificationsConfig(theme, colors,t,navigate,props.onClose,isRelation));
    }, [theme,i18n.language,isRelation]);


    return (
        <PopoverModal
            zIndex={1199}
            triangle={{position:"right"}}
            {...props}
        >
            <TabView3
                viewType={"popup"}
                tabConfig={config}  
                sx={{
                    minWidth:320,
                    
                    background: "green",
                    minHeight: "calc(100% - 190px)",
                    background: `${
                      theme.palette.mode === "dark"
                        ? colors.grey[200]
                        : colors.grey[0]
                    }`,
                    position: "relative",
                    zIndex: 2,
                    display: "flex",
                    flexDirection: "column",
      
                    "&:before": {
                        content: "''",
                        display: "block",
                        width: "32px",
                        height: "32px",
                        position: "absolute",
                        left: 0,
                        zIndex: 0,
                        backgroundColor: `${
                            theme.palette.mode === "dark"
                            ? colors.grey[200]
                            : colors.grey[0]
                        }`,
                        top: "40px",
                        height: "48px",
                        width: "24px",
                        borderTopLeftRadius: "16px",
                        boxShadow: `0 -24px 0 0 ${colors.bg["tertiary"]}`,
                        transition: "250ms",
                    },
      
                    "&:after": {
                        content: "''",
                        display: "block",
                        width: "32px",
                        height: "32px",
                        position: "absolute",
                        top: 0,
                        zIndex: 0,
                        backgroundColor: `${
                            theme.palette.mode === "dark"
                            ? colors.grey[200]
                            : colors.grey[0]
                        }`,
                        top: "40px",
                        right: 0,
                        height: "48px",
                        width: "24px",
                        borderTopLeftRadius: "16px",
                        boxShadow: `0 -24px 0 0 ${colors.bg["tertiary"]}`,
                        transform: "scaleX(-1)",
                        transition: "250ms",
                    },
      
                    "@media screen and (max-width: 47.9375em)": {
                        "&:after, &:before": {
                            top: "-0px",
                        },
                    },
                }}
            >
                <>
                    <Notifications {...props} data={props.data} config={config.notifications}/>
                    <TopbarNews {...props} config={config.news}/>
                </>

            </TabView3>

        </PopoverModal>
    );
}

export default MPONotifications;

let gridOptions = {
    export: true,
    disableCustomActionsOnPhone: true,
    isSidepanel: true,
};


const Notifications = (props) => {
    const theme = useTheme();
    const {t} = useTranslation();
    const colors = tokens(theme.palette.mode);
    const navigate = useNavigate();
    
    let isStandAlone = false;
    if (window.matchMedia('(display-mode: standalone)').matches) {
        isStandAlone = true;
    }
    const [markNotificationAsRead,{isLoading:notificationsLoading}] = useMarkAllNotificationsAsReadMutation();

    const selectedEnvironmentType = useSelector((state) => state.settings.environment.selectedEnvironmentType);
    const isRelation = selectedEnvironmentType === ENV_TYPES[200];

    useEffect(() => {
        props.replaceView({
            ...props.config,
            gridOptions: gridOptions,
        });

        return () => {
            
        }
    }, []);

    return (
        <Box>
            <Box 
                sx={{
                    zIndex:1,
                    maxHeight:470,
                    overflow:"auto",
                    background: theme.palette.mode === "dark" ? colors.grey[200] : "#fff",
                    // mb:"-12px",
                    paddingBottom: isStandAlone ? 1 : 0,
                    display:"flex",
                    flexDirection:"column",
                }}
            >
                {props?.data?.notifications?.length ?
                    <NotificationsContent 
                        {...props} 
                        data={props.data}
                        compSx={{ minWidth: 450 }}
                    />
                : 
                    <Box
                        sx={{
                            p:3,
                            pt:1,
                            mt:'auto',
                            mb:"auto",
                            display:"flex",
                            flexDirection:"column",
                            alignItems:"center",
                            justifyContent:'center',
                        }}
                    >
                        <TableEmpty/>
                        <Box
                            sx={{
                                mt:1,
                                display:"flex",
                                flexDirection:"column",
                                gap:0.5
                            }}
                        >
                            <Subheading textAlign="center">{t('notifications_empty_title')}</Subheading>
                            <Text align="center" light>{t('no_notifications_found')}</Text>
                        </Box>
                    </Box>
                }
            </Box>
            {props?.data?.notifications  &&
                <Box
                    sx={{
                        p:2,
                        py:1.5,
                        pl: props?.data?.remaining > 0 ? 1.5 : 2,
                        display:'flex',
                        justifyContent:'space-between',
                        borderTop:`1px solid ${theme.palette.mode === "dark" ? colors.grey[300]: colors.grey[100]}`,
                        boxShadow:theme.palette.mode === "dark" ? null :  `0px 0px 8px ${colors.grey[200]}`,
                    }}
                >
                    {props?.data?.remaining > 0  &&
                        <ButtonBase
                            disabled={notificationsLoading}
                            onClick={() => {
                                if(!notificationsLoading){
                                    markNotificationAsRead().unwrap().then(res => {
                                        showToastMessage("success", t("notifications_marked_as_read"));
                                        props.onClose();
                                    }).catch(err => {
                                        showToastMessage("error", t("notifications_marked_as_read_failed"));
                                    })
                                }
                            }}
                            sx={{
                                height:32,
                                borderRadius:5,
                                px:2,
                                display:"flex",
                                alignItems:"center",
                                justifyContent:'center',
                                // background: theme.palette.mode === "dark" ? colors.blue[400] : colors.primary[400],
                                color: theme.palette.mode === "dark" ? colors.blue[400] : colors.primary[400],
                                fontSize:14,
                                fontWeight:700,
                                fontFamily:"Roboto, sans-serif",
                            }}
                        >
                            <DoneAllOutlinedIcon sx={{
                                mr:1,
                            }} />
                            {t("mark_all_read")}
                        </ButtonBase>
                    }
                    <ButtonBase
                        onClick={() => {
                            if(isRelation){
                                navigate("/relation/notifications");
                            } else{
                                navigate("/warehouse/notifications");
                            }
                            props.onClose();
                        }}
                        sx={{
                            width: props?.data?.remaining > 0 ? null : 1,
                            height:32,
                            borderRadius:5,
                            px:2,
                            display:"flex",
                            alignItems:"center",
                            justifyContent:'center',
                            background: theme.palette.mode === "dark" ? colors.blue[400] : colors.primary[400],
                            color: theme.palette.mode === "dark" ? colors.txt["primaryDark"] : colors.txt["light"],
                            fontSize:14,
                            fontWeight:700,
                            fontFamily:"Roboto, sans-serif",
                        }}
                    >
                        {t("view_all")}
                    </ButtonBase>
                </Box>
            }
        </Box>
   
    )
}

const PpEsturiaEsf = (props) => {
    const theme = useTheme();
    const {t} = useTranslation();
    const colors = tokens(theme.palette.mode);
    
    let isStandAlone = false;
    if (window.matchMedia('(display-mode: standalone)').matches) {
        isStandAlone = true;
    }


    useEffect(() => {
        props.replaceView({
            ...props.config,
            gridOptions: gridOptions,
        });

        return () => {
            
        }
    }, []);

    return (
        <Box
            sx={{
                zIndex:1,
                height:400,
                overflow:"auto",
                background: theme.palette.mode === "dark" ? colors.grey[100] : "#fff",
                // mb:"-12px",
                paddingBottom: isStandAlone ? 1 : 0,
                display:"flex",
                flexDirection:"column",
            }}
        >
            hellowowo
        </Box>
   
    )
}